module.exports = __webpack_public_path__ + "static/media/29BDOS10.b2f763bc.jpg";